<template>
  <div id="sidebar_menu" class="sidebar" :class="{'active' : isOpen}" ref="sidebar">
    <div class="sidebar-backdrop" @click.prevent="closeSidebar"></div>
    <div class="sidebar-wrapper">
      <button class="btn-close" @click.prevent="closeSidebar" v-if="!isExtend">
        <img src="@/assets/img/ico_close.svg" alt="btn_close" />
      </button>
      <button class="btn-close" @click.prevent="extendSidebar(false)" v-if="isExtend">
        <img src="@/assets/img/ico_arrow_left.svg" alt="btn_close" />
      </button>
      <div class="sidebar-main" :class="{ 'active' : !isExtend}">
        <div class="item mb-60" v-if="!isShowItem" @click.prevent="closeSidebar">
          <router-link :to="{name: 'Login'}"
            >{{ $t('common.sidebar.account') }}</router-link>
        </div>
        <div class="item mb-60 item-info" v-else @click.prevent="closeSidebar">
          <router-link :to="{name: 'Account'}">
            <div class="user-info">
              <img class="user-icon" :src="'/static/public_user_icon/'+$constant.USER_ICON_LIST[userInfo.icon_type - 1]" alt="ico_user">
              <div>
                <div class="user-name">{{ userInfo.user_name }}</div>
                <div class="user-mail">{{ userInfo.mail }}</div>
              </div>
            </div>
          </router-link>
        </div>
        <!-- role account -->
        <div class="item" v-if="this.userInfo.account_level === this.$constant.ADMIN_LEVEL" @click.prevent="closeSidebar">
          <router-link :to="{name: 'ManagerConstruction'}"
            >{{ $t('案件管理') }}</router-link>
        </div>
        <div class="item" v-if="this.userInfo.account_level === this.$constant.SUPERVISOR_LEVEL" @click.prevent="closeSidebar">
          <router-link :to="{name: 'ListConstruction', params: {manager_user_id: this.userInfo.user_id}}"
            >{{ $t('案件管理') }}</router-link>
        </div>
        <div class="item mb-60" v-if="this.userInfo.account_level === this.$constant.ADMIN_LEVEL" @click.prevent="closeSidebar">
          <router-link :to="{name: 'SupervisorList'}"
            >{{ $t('アカウント管理') }}</router-link>
        </div>
        <div class="item mb-60" v-if="this.userInfo.account_level === this.$constant.SUPERVISOR_LEVEL" @click.prevent="closeSidebar">
          <router-link :to="{name: 'OperatorList', params: {manager_user_id: this.userInfo.user_id}}"
            >{{ $t('アカウント管理') }}</router-link>
        </div>
        <!-- end -->
        <div class="item" @click.prevent="closeSidebar" :class="{'d-none': hideContent}">
          <router-link :to="{name: 'Notification'}"
            >{{ $t('common.sidebar.notification') }}</router-link>
        </div>
        <div class="item" @click.prevent="goToExternalUrl('https://guide.zengo.work/')">
          <a href="#">
          {{ $t('common.sidebar.guide') }}</a>
        </div>
        <div class="item" @click.prevent="closeSidebar">
          <router-link :to="{name: 'ContactForm'}"
            >{{ $t('common.sidebar.contact_us') }}</router-link>
        </div>
        <div class="item" @click.prevent="closeSidebar">
          <router-link :to="{name: 'FAQ'}"
            >{{ $t('common.sidebar.faq') }}</router-link>
        </div>
        <div class="item item-extend mb-60">
          <a href="javascript:void(0)" @click.prevent="extendSidebar(true)"
            >{{ $t('common.sidebar.other') }}</a>
          <img class="ico-extend" src="@/assets/img/ico_arrow_right.svg" alt="ico_right" />
        </div>
        <div class="item" v-if="isShowItem" @click.prevent="logout">
          <a href="#">{{ $t('common.sidebar.logout') }}</a>
        </div>
      </div>
      <div class="sidebar-extend" :class="{ 'active' : isExtend }">
        <div class="item" @click.prevent="closeSidebar">
          <router-link :to="{name: 'TermsOfService'}"
            >{{ $t('common.sidebar.term_service') }}</router-link>
        </div>
        <div class="item" @click.prevent="closeSidebar" :class="{'d-none': hideContent}">
          <router-link :to="{name: 'SpecifiedCommodityTransactionLaw'}"
            >{{ $t('common.sidebar.commercial_law') }}</router-link>
        </div>
        <div class="item" @click.prevent="goToExternalUrl('https://lecre.jp/privacy/')">
          <div>{{ $t('common.sidebar.privacy_policy') }}</div>
        </div>
        <div class="item" @click.prevent="goToExternalUrl('https://lecre.jp/')">
          <div>{{ $t('common.sidebar.company') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {API_LOGOUT} from '@/configs/api.js'

export default {
  name: 'MainSidebar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isExtend: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
    }),
    ...mapState({
      hideContent: state => state.hideContentByAppVersion
    }),
    isShowItem () {
      return this.userInfo && this.userInfo.user_id;
    }
  },
  methods: {
    closeSidebar () {
      this.$emit('openSidebar', false)
    },
    extendSidebar (value) {
      this.$emit('extendSidebar', value)
    },
    async logout () {
      this.closeSidebar();
      try {
        let resLogout = await this.$api.post(API_LOGOUT);
        if (resLogout.data.code === 200) {
          this.$store.dispatch('logout')
          this.$router.push({name: 'Login'})
        } else {
          alert(resLogout.data.error_message)
        }
      } catch (error) {
        console.error(error);
        alert(error)
      }
    },
    goToExternalUrl (extUrl) {
      this.closeSidebar();
      window.open(extUrl, '_blank');
    }
  }
};
</script>

<style scoped>
.sidebar-main .item a, .sidebar-extend .item div {
  width: 100%;
  min-height: 60px;
  background-color: #72C9C0;
  display: block;
  padding-left: 30px;
  font-size: 16px;
  color: #fff;
  margin-bottom: 2px;
  line-height: 60px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
}
.sidebar-main .item-info a, .sidebar-extend .item-info div {
  min-height: 80px;
  font-size: 16px;
  line-height: 20px;
  font-weight: unset;
}
.user-icon {
  width: 32px;
  height: 32px;
}
.user-name {
  font-weight: bold;
}
.user-info {
  display: flex;
  padding: 20px 5px 20px 0;
}
.user-info img {
  margin-right: 10px;
  margin-top: 4px;
}
.user-mail {
  width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 319px) and (min-width: 279px) {
  .user-mail, .user-name {
    width: 180px;
  }
}

@media screen and (max-width: 279px) and (min-width: 239px) {
  .user-mail, .user-name {
    width: 150px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/layouts/MainSidebar.vue